var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#D71924"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2288_1059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4663 46.3602C16.1432 46.8448 16.2742 47.4997 16.7588 47.8228C16.9387 47.9426 17.1419 48 17.3429 48C17.6837 48 18.0182 47.8351 18.2214 47.5302L19.0252 46.3245C18.3745 46.0389 17.7546 45.6959 17.1726 45.3008L16.4663 46.3602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8278 45.3008C42.2457 45.6959 41.6258 46.0389 40.9751 46.3245L41.7789 47.5302C41.9822 47.8351 42.3165 48 42.6574 48C42.8584 48 43.0617 47.9426 43.2415 47.8228C43.7262 47.4997 43.8571 46.8448 43.534 46.3602L42.8278 45.3008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1799 32.4004V35.6951C14.1799 40.9291 18.4381 45.1873 23.6721 45.1873H36.3284C41.5624 45.1873 45.8206 40.9291 45.8206 35.6951V35.081H28.393C23.4899 35.081 18.7173 34.1794 14.1799 32.4004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6951 24.4305V15.8672C17.6951 14.8979 18.4836 14.1094 19.4529 14.1094H20.8591C21.8284 14.1094 22.6169 14.8979 22.6169 15.8672V16.3676C20.9865 16.8374 19.8044 18.3675 19.8044 20.1446V20.4375C19.8044 21.02 20.2767 21.4922 20.8591 21.4922H26.4841C27.0666 21.4922 27.5388 21.02 27.5388 20.4375V20.0859C27.5388 18.3192 26.3475 16.8263 24.7263 16.3659V15.8672C24.7263 13.7348 22.9915 12 20.8591 12H19.4529C17.3205 12 15.5857 13.7348 15.5857 15.8672V23.5836C15.7518 23.6346 15.9157 23.6946 16.0767 23.766C16.6117 24.0037 17.1513 24.2249 17.6951 24.4305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6884 28.4903H28.393C23.8253 28.4903 19.3947 27.5498 15.2224 25.6953C14.0894 25.1935 12.7667 25.702 12.264 26.8327C11.7614 27.9636 12.2706 29.2884 13.4014 29.7911C18.1508 31.9024 23.1942 32.9726 28.393 32.9726H45.6886C46.9266 32.9726 47.9298 31.9695 47.9298 30.7314C47.9296 29.4933 46.9265 28.4903 45.6884 28.4903Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2288_1059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon04);
export default __webpack_public_path__ + "static/media/icon_04.5945c648df9ea5d6a3e5a8dd7af406a3.svg";
export { ForwardRef as ReactComponent };